export const INotificationsPermissionScreenViewModelType = Symbol('INotificationsPermissionScreenViewModel');
